












































































import { Component, Vue } from "vue-property-decorator";
@Component({
    name: "ButtonSeven"
})
export default class ButtonSix extends Vue { }
